var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIskustvoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 41,
    height: 7,
    fill: "#FFECE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8871 45.0948L45.0746 42.9948C45.1981 41.6322 44.8207 40.2713 44.0131 39.1669C43.2055 38.0624 42.023 37.2902 40.6871 36.9948L33.8433 35.4761V27.0573C33.8786 26.574 33.8139 26.0887 33.6533 25.6315C33.4926 25.1744 33.2394 24.7553 32.9095 24.4004C32.5796 24.0455 32.18 23.7624 31.7358 23.5689C31.2916 23.3753 30.8123 23.2754 30.3277 23.2754C29.8431 23.2754 29.3638 23.3753 28.9196 23.5689C28.4754 23.7624 28.0758 24.0455 27.7459 24.4004C27.416 24.7553 27.1628 25.1744 27.0021 25.6315C26.8415 26.0887 26.7768 26.574 26.8121 27.0573V41.9636L23.9996 39.8823C23.4464 39.4606 22.7589 39.2542 22.0649 39.3016C21.3709 39.349 20.7178 39.6469 20.2271 40.1399C19.7364 40.6329 19.4415 41.2874 19.3974 41.9816C19.3532 42.6758 19.5628 43.3624 19.9871 43.9136L20.8683 45.0948",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0938 31.0312V5.71875C45.0938 4.97283 44.7974 4.25746 44.27 3.73001C43.7425 3.20257 43.0272 2.90625 42.2812 2.90625H5.71875C4.97283 2.90625 4.25746 3.20257 3.73001 3.73001C3.20257 4.25746 2.90625 4.97283 2.90625 5.71875V36.6562C2.90625 37.4022 3.20257 38.1175 3.73001 38.645C4.25746 39.1724 4.97283 39.4688 5.71875 39.4688H14.1562",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 11.3438H45.0938",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 17.9062H19.3125C19.3125 17.9062 20.7188 17.9062 20.7188 19.3125V31.5C20.7188 31.5 20.7188 32.9062 19.3125 32.9062H10.875C10.875 32.9062 9.46875 32.9062 9.46875 31.5V19.3125C9.46875 19.3125 9.46875 17.9062 10.875 17.9062Z",
    fill: "#FFECE2",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2812 17.9062H38.5312",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIskustvoDark);
export default __webpack_public_path__ + "static/media/iskustvo-dark.cdc6ff6dce9384eefc17c0dff6647f46.svg";
export { ForwardRef as ReactComponent };